import React, { useCallback, useEffect, useState } from "react";
import ContestwiseEarn from "../../components/Dashboard/ContestwiseEarn";
import Dashboard from "../../components/Dashboard/Dashboard";
import { getDashboardData } from "../../redux/services/dashboardSlice";
import { useDispatch } from "react-redux";
import { convertUtcToIst } from "../../utils/TimeUtils";
import Privacy from "../../components/Dashboard/Privacy";
import { useUser } from "../../redux/services/authSlice";

const DashboardPage = () => {
  const dispatch = useDispatch();
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  const [toggle, setToggle] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const { user } = useUser();
    const handleDateSubmit = () => {
      let adjustedStartDate = null;
      if (startDate) {
        adjustedStartDate = new Date(startDate);
        adjustedStartDate.setHours(0, 0, 0, 0);
      }

      let adjustedEndDate = null;
      if (endDate) {
        adjustedEndDate = new Date(endDate);
        adjustedEndDate.setHours(23, 59, 59, 999);
      }
      const SDate = adjustedStartDate ? convertUtcToIst(adjustedStartDate) : null;
      const EDate = adjustedEndDate ? convertUtcToIst(adjustedEndDate) : null;

      if (SDate && EDate) {
        setToggle(false);
        getAllDashboardData(SDate, EDate);
        setStartDate(null);
        setEndDate(null);
      } else {
        getAllDashboardData();
      }

      return { SDate, EDate };
    };

  const getAllDashboardData = useCallback(async (SDate, EDate) => {
    try {
      const payload = { startDate: SDate, endDate: EDate };
      const response = await dispatch(getDashboardData(payload));
      setToggle(false);
      setData1(response.payload?.data?.sec1);
      setData2(response.payload?.data?.sec2);
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
    }
  }, [dispatch]);
  
  useEffect(() => {
    getAllDashboardData(); 
  }, [getAllDashboardData]); 
  return (
    <div className="overflow-hidden space-y-6 p-4">
      <Dashboard data={data1} earning={data2} />
      <ContestwiseEarn
        data={data2}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        handleDateSubmit={handleDateSubmit}
        startDate={startDate}
        endDate={endDate}
        setToggle={setToggle}
        toggle={toggle}
      />
      {(user?.privacyPolicy?.trim() !== "string" ||
        user?.termsAndConditions?.trim() !== "string") && (
        <Privacy
          privacyPolicyData={user?.privacyPolicy}
          termsAndConditionsData={user?.termsAndConditions}
        />
      )}
    </div>
  );
};

export default DashboardPage;
